export default {
  props: ['id'],
  computed: {
    user() { return this.$store.state.user; },
    loading() { return this.$store.state.loading; },
    results() {
      return this.$store.state.courses.testResultsList
        .filter(i => i.finished)
        .map((i, cnt, arr) => ({
          ...i, counter: arr.length - cnt,
        }));
    },
  },
  methods: {
    correctPercent(correct, wrong, all) {
      return (all > 0) ? Math.round(correct / (all / 100)) : 0;
    },
    wrongAnswers(item) {
      return item.results.filter(i => !i.is_correct);
    },
  },
  mounted() {
    this.$store.dispatch('courses/GetResultsList', { profile_id: this.user.profile_id, test_id: this.id });
  },
};
